import { useRouter } from "next/router";

import { Modal } from "shared/ui";
import { Button } from "shared/ui/shadcn/button";
import { Separator } from "shared/ui/shadcn/separator";

import Router from "@/helpers/router";
import { useListsStore } from "@/modules/list-workspace/store/lists-store";

export const USER_ALREADY_HAS_LEADS_MODAL_ID = "user-already-has-leads-modal";

export const UserAlreadyHasLeadsModal = () => {
  const router = useRouter();
  const availableToCallColdLeadsForUser =
    useListsStore((state) => state.availableToCallColdLeadsForUser) || [];

  return (
    <Modal
      id={USER_ALREADY_HAS_LEADS_MODAL_ID}
      title="You already have leads assigned"
      description="Please call your remaining leads first, located in the lists shown below. Then, try loading more again."
    >
      {({ handleClose }) => {
        return (
          <div className="mt-4 flex flex-col">
            {availableToCallColdLeadsForUser.map((item, index) => (
              <div key={item.list_id}>
                <Button
                  variant="ghost"
                  className="flex w-full items-center justify-between rounded-none"
                  onClick={() => {
                    router.push(Router.lists(item.list_id));
                    handleClose();
                  }}
                >
                  <span className="typography-body-4-semibold">
                    {item.list_name}
                  </span>
                  <span className="text-black/80 typography-body-4">
                    {item.count} cold leads available
                  </span>
                </Button>

                {index < availableToCallColdLeadsForUser.length - 1 && (
                  <Separator className="my-0" />
                )}
              </div>
            ))}
          </div>
        );
      }}
    </Modal>
  );
};
